import { AuthApp } from "../layouts/auth/AuthApp.js";
import { UserAuthApp } from "../layouts/auth/UserAuthApp.js";
import { ProviderAuthApp } from "../layouts/auth/ProviderAuthApp.js";
import { StaffAuthApp } from "../layouts/auth/StaffAuthApp.js";
import { routes } from "../utlis/admin/routes.utlis.js";
import { routes as userroutes } from "../utlis/user/routes.utlis.js";
import { routes as providerroutes } from "../utlis/provider/routes.utlis.js";
import { routes as staffroutes } from "../utlis/staff/routes.utlis.js";
import AdminLogin from "../views/auth/admin/Page.js";
import Home from "../views/auth/user/Home.js";
import Login from "../views/auth/user/Login.js";
import SignUp from "../views/auth/user/SignUp.js";
import UserRegister from "../views/auth/user/UserRegister.js";
import Register from "../views/auth/provider/Register.js";
import StaffRegister from "../views/auth/staff/Register.js";
import About from "../views/common/About.js";
import Privacy from "../views/common/Privacy.js";
import Term from "../views/common/Term.js";
import Subscription from "../views/common/Subscription.js";
import Contact from "../views/common/Contact.js";
import Blog from "../views/auth/user/Blog.js";
import BlogDetail1 from "../views/auth/user/BlogDetail1.js";
import BlogDetail2 from "../views/auth/user/BlogDetail2.js";
import BlogDetail3 from "../views/auth/user/BlogDetail3.js";

var AuthRoutes = [
  {
    path: routes.login,
    exact: true,
    layout: AuthApp,
    component: AdminLogin,
  },
  {
    path: userroutes.home,
    exact: true,
    layout: UserAuthApp,
    component: Home,
  },
  {
    path: userroutes.about,
    exact: true,
    layout: UserAuthApp,
    component: About,
  },
  {
    path: userroutes.privacy,
    exact: true,
    layout: UserAuthApp,
    component: Privacy,
  },
  {
    path: userroutes.term,
    exact: true,
    layout: UserAuthApp,
    component: Term,
  },
  {
    path: userroutes.subscription,
    exact: true,
    layout: UserAuthApp,
    component: Subscription,
  },
  {
    path: userroutes.contact,
    exact: true,
    layout: UserAuthApp,
    component: Contact,
  },
  {
    path: userroutes.login,
    exact: true,
    layout: UserAuthApp,
    component: Login,
  },
  {
    path: userroutes.blog,
    exact: true,
    layout: UserAuthApp,
    component: Blog,
  },
  {
    path: userroutes.blogDetail1,
    exact: true,
    layout: UserAuthApp,
    component: BlogDetail1,
  },
  {
    path: userroutes.blogDetail2,
    exact: true,
    layout: UserAuthApp,
    component: BlogDetail2,
  },
  {
    path: userroutes.blogDetail3,
    exact: true,
    layout: UserAuthApp,
    component: BlogDetail3,
  },
  {
    path: userroutes.userRegister,
    exact: true,
    layout: UserAuthApp,
    component: UserRegister,
  },
  {
    path: userroutes.signup,
    exact: true,
    layout: UserAuthApp,
    component: SignUp,
  },
  {
    path: providerroutes.providerRegister,
    exact: true,
    layout: ProviderAuthApp,
    component: Register,
  },
  {
    path: staffroutes.staffRegister,
    exact: true,
    layout: StaffAuthApp,
    component: StaffRegister,
  },
];

export default AuthRoutes;